import { useEffect, useRef, useState } from "react";
import AdvanceRightModal from "../../../components/Modal/AdvanceRightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { handleDropdownClose } from "../../../utils/utils";
import AdvancePropertyFilterData from "./AdvancePropertyFilterData";

// ✅ REAL empty state (used for clear + API)
const EMPTY_ADVANCE_FILTER = [];

const ContactAdvanceFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(
    localStorage.getItem("selectedSavefilterId") || ""
  );

  // ✅ UI-only empty row
  const initialEmptyState = [
    {
      id: Date.now(),
      condition: "AND",
      filters: [{ join: null, field: "", operator: "", value: "" }],
    },
  ];

  const [localFilterData, setLocalFilterData] = useState(
    filterData?.length ? filterData : initialEmptyState
  );

  /* ---------------- SYNC WHEN OPEN ---------------- */
  useEffect(() => {
    if (isSidebarOpen) {
      setLocalFilterData(filterData?.length ? filterData : initialEmptyState);
    }
  }, [isSidebarOpen, filterData]);

  useEffect(() => {
    handleDropdownClose(dropdownRef, () => setIsSidebarOpen(false));
  }, []);

  /* ---------------- APPLY FILTER ---------------- */
 const handleFilter = () => {
    onSetFilterData(localFilterData);
    onCallApiAgain(localFilterData);
    localStorage.setItem("advanceFilterData", JSON.stringify(localFilterData));
    localStorage.setItem("filterData", JSON.stringify(localFilterData));
    setIsSidebarOpen(false);
  };

  /* ---------------- CLEAR FILTER (FIXED) ---------------- */
  const handleClearAll = () => {
    // ✅ real clear
    onSetFilterData(EMPTY_ADVANCE_FILTER);
    onCallApiAgain(EMPTY_ADVANCE_FILTER);

    // ✅ UI reset
    setLocalFilterData(initialEmptyState);

    // ✅ fixed function name
    setSelectedSaveFilterId("");

    localStorage.removeItem("advanceFilterData");
    localStorage.removeItem("selectedSavefilterId");

    setIsSidebarOpen(false);
  };

  const handleClearFromSavedFilter = () => {
    // ✅ This gets called from SavedFilterComponent's Clear button
    onSetFilterData(EMPTY_ADVANCE_FILTER);
    onCallApiAgain(EMPTY_ADVANCE_FILTER);
    setLocalFilterData(initialEmptyState); // 👈 This was missing!
    setSelectedSaveFilterId("");
  };


  /* ---------------- SELECT SAVED FILTER ---------------- */
 const handleSelectFilter = (value) => {
    // ✅ Extract advance_filters from saved search
    const filters = value?.advance_filters || EMPTY_ADVANCE_FILTER;

    onSetFilterData(filters);
    onCallApiAgain(filters);
    setLocalFilterData(filters.length ? filters : initialEmptyState);

    localStorage.setItem("advanceFilterData", JSON.stringify(filters));
    localStorage.setItem("filterData", JSON.stringify(filters));
  };

  /* ---------------- SAVE DATA ---------------- */
  const saveSearchFilterData = {
    advance_filters: localFilterData,
  };

  /* ---------------- CORRECT COUNT ---------------- */
  const filterCount =
    localFilterData?.filter(group =>
      group?.filters?.some(
        f => f.field || f.operator || f.value
      )
    ).length || 0;

  return (
    <>
      {/* SAVED FILTER HEADER */}
      <SavedFilterComponent
        from="property"
        filterType="advance"
        count={filterCount}
        isSidebarOpen={isSidebarOpen}
        initialFilterData={EMPTY_ADVANCE_FILTER}
        selectedSavefilterId={selectedSavefilterId}
        saveSearchFilterData={saveSearchFilterData}
        onSetIsSidebarOpen={setIsSidebarOpen}
        onSetFilterData={handleClearFromSavedFilter}
        onCallApiAgain={onCallApiAgain}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
      />


      {/* ADVANCE FILTER MODAL */}
      <AdvanceRightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Advance Filter"
        from="property"
        onFilter={handleFilter}
        onClose={() => setIsSidebarOpen(false)}
        onClearAll={handleClearAll}
      >
        <AdvancePropertyFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={localFilterData}
          onSetFilterData={setLocalFilterData}
        />
      </AdvanceRightModal>
    </>
  );
};

export default ContactAdvanceFilter;
